<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button style="margin-right: 10px" @click="exportList">
          导出
        </el-button>

        <el-button
          style="margin-right: 10px"
          type="primary"
          v-hp="'retry'"
          @click="restExceptionTaskSelection"
        >
          立即重试
        </el-button>
      </div>
    </customize-page>

    <el-dialog width="80%" title="轨迹日志" :visible.sync="dialogTableVisible">
      <el-table
        :row-class-name="tableRowClassName"
        :data="traceLogData"
        height="380"
      >
        <el-table-column
          property="appName"
          label="应用"
          width="120"
        ></el-table-column>
        <el-table-column
          property="time"
          label="时间"
          width="100"
        ></el-table-column>
        <el-table-column property="content" label="内容">
          <template slot-scope="scope">
            <div v-html="scope.row.content"></div>
          </template>
        </el-table-column>
        <el-table-column
          property="traceLevel"
          label="级别"
          width="60"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<style>
.el-table .warning-row {
  background: #fdf5c9;
}

.el-table .debug-row {
  background: #b9f9ba;
}

.el-table .success-row {
  background: #b9f9ba;
}

.el-table .error-row {
  background: #f95c54;
}
</style>
<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import { mapGetters } from "vuex";
import { CONST_VD_IMGPREFIX } from "@/config/constant";
import exceptionTaskApi from "@/api/exceptionTaskApi";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    let initParam = this.$store.state.app.sc["exceptionTaskList"];
    if (initParam) {
      this.pagination.currentPage = initParam.request.pageIndex;
      this.pagination.pageSize = initParam.request.pageSize;
      this.filterObj = initParam.request.condition;
    }
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      traceLogData: [],
      dialogTableVisible: false,
      loading: false,
      dataList: [],
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "原始单号/清单编号",
          key: "originOrderNo",
          width: 200,
          align: "center",
          render: (h, params) => {
            const bizId = params.row.bizId;
            const originOrderNo = params.row.originOrderNo;
            return (
              <div>
                <a
                  style="color:blue"
                  onClick={this.showDetail.bind(this, bizId)}
                >
                  {originOrderNo}
                </a>
                <p>{params.row.billNo}</p>
              </div>
            );
          },
        },
        {
          title: "渠道来源",
          width: 150,
          key: "bizType",
          align: "center",
        },
        {
          title: "异常信息",
          width: 200,
          key: "memo",
          align: "center",
        },
        {
          title: "异常状态",
          width: 180,
          key: "taskStatus",
          align: "center",
        },
        {
          title: "异常类型",
          width: 150,
          key: "taskType",
          align: "center",
        },
        {
          title: "创建时间",
          width: 200,
          key: "gmtCreate",
          align: "center",
        },
        {
          title: "最后执行时间",
          width: 200,
          key: "gmtModified",
          align: "center",
        },
        {
          title: "操作",
          width: 200,
          align: "center",
          render: (h, params) => {
            let operation = [];
            operation.push(
              <el-button
                type="text"
                onClick={this.restExceptionTask.bind(this, params.row.id)}
              >
                重试
              </el-button>
            );
            if (this.$hasPermission(this.$route, "record")) {
              operation.push(
                <el-button
                  type="text"
                  onClick={this.showTracelogDetail.bind(this, params.row)}
                >
                  轨迹日志
                </el-button>
              );
            }
            return <div>{operation}</div>;
          },
        },
      ],
      filterObj: {
        stockoutOrderId: "",
        bizId: "",
        exceptionType: "",
        taskStatus: "WAIT_HANDLE",
        warehouseId: "12",
        merchantId: "",
        memo: "",
        notmemo: "",
        merchantOrderNo: "",
      },
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {
    ...mapGetters({
      getPECommerce: "getPECommerce",
    }),
    isShangHaiEnv() {
      return CONST_VD_IMGPREFIX.env === "SHANGHAI";
    },
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      let traceLevel = row.traceLevel;
      if (traceLevel === "DEBUG") {
        return "debug-row";
      } else if (traceLevel === "WRAN") {
        return "warning-row";
      } else if (traceLevel === "INFO") {
        return "success-row";
      } else {
        return "error-row";
      }
    },
    showDetail(id) {
      this.$router.push({
        name: "customsDeclareDetail",
        params: { id },
      });
    },
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();

      const sortObj = this.sortObj;

      let searchCondition = {
        ...sortObj,
        request: {
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...filterParams,
        },
      };

      this.$store.dispatch("sc", {
        page: "exceptionTaskList",
        param: searchCondition,
      });
      let __this = this;
      this.$store
        .dispatch("exceptionTaskList", searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.page || { totalCount: 0 };
          __this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    restExceptionTask(ids) {
      this.loading = true;
      this.$store
        .dispatch("reException", {
          taskIds: ids,
        })
        .then((res) => {
          this.loading = false;
          if (res.isSuccess) {
            this.$message.success("成功");
          } else {
            this.$message.error(
              "失败的任务：" + res.resultMessage || "重推失败"
            );
          }
          this.fetch();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    restExceptionTaskSelection() {
      if (this.currentRow.length <= 0) {
        this.$message.warning("请勾选需要重推的清单");
        return;
      }
      var ids = "";
      for (let index in this.currentRow) {
        ids += this.currentRow[index].id + ",";
      }
      this.restExceptionTask(ids);
    },
    showTracelogDetail(row) {
      this.traceLogData = [];
      let bizId = row.bizId;
      this.loading = true;
      this.$store
        .dispatch("traceDetail", {
          bizId,
        })
        .then((res) => {
          this.loading = false;
          this.traceLogData = res.tracelogItems;
          this.dialogTableVisible = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    exportList() {
      this.loading = true;
      const filterParams = this.getFilterParams();

      exceptionTaskApi
        .exportTask({
          request: {
            ...filterParams,
            pageInfo: {
              currentPage: 1,
              pageSize: 9999,
            },
          },
        })
        .then((res) => {
          if (res.value) {
            this.$alert("提交成功", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push({ name: "download" });
              },
            });
          } else {
            this.$message.error("提交失败");
          }
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "货主id",
              model: "customerId",
              type: type.INPUT,
            },
            {
              label: "商户订单号",
              model: "merchantOrderNo",
              type: type.INPUT,
            },
            {
              label: "出库单号",
              model: "stockoutOrderId",
              type: type.INPUT,
            },
            {
              label: "销售单号",
              model: "bizId",
              type: type.INPUT,
            },
            {
              label: "状态",
              model: "taskStatus",
              type: type.SELECT,
              props: {
                data: [
                  { value: "WAIT_HANDLE", label: "待处理" },
                  { value: "HANDLE_SUCCESS", label: "处理成功" },
                ],
              },
            },
            {
              label: "仓库",
              model: "warehouseId",
              type: type.SELECT,
              props: {
                data: [{ value: "15", label: " 系统仓（NC系统配置）" }],
              },
            },
            {
              label: "渠道",
              model: "merchantId",
              type: type.SELECT,
              props: {
                data: this.getPECommerce,
              },
            },
            {
              label: "包含异常",
              model: "memo",
              type: type.INPUT,
            },
            {
              label: "不含异常",
              model: "notmemo",
              type: type.INPUT,
            },
          ],
        },
      ];
    },
  },
};
</script>
